import React from "react";
import { Link } from "react-router-dom";
import logo from "../Components/Assets/logo1.jpeg";

import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt
} from "react-icons/fa";

import "../../../src/Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">

        {/* Row Layout */}
        <div className="footer-row">

          {/* Logo */}
          <div className="footer-logo-img">
            <img src={logo} alt="logo" />
          </div>

          {/* Brand */}
          <div className="footer-col">
            <Link to="/" className="footer-logo">
              Ezer<span>Booking</span>
            </Link>

            <p className="footer-desc">
              Smart and secure event booking solutions.
            </p>

            <div className="social-links">
              <a href="#"><FaFacebookF /></a>
              <a href="#"><FaTwitter /></a>
              <a href="#"><FaInstagram /></a>
              <a href="#"><FaLinkedinIn /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/flashdeals">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col contact-info">
            <h4>Contact</h4>
            <p><FaEnvelope /> support@ezerbooking.com</p>
            <p><FaPhoneAlt /> +91 9652984415</p>
            <p><FaMapMarkerAlt /> Hyderabad</p>
          </div>

        </div>

        {/* Bottom */}
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} EzerBooking. All rights reserved.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;